import { Component, OnInit, ElementRef, Input, Output, ViewChild, EventEmitter, HostListener, Injector, ChangeDetectorRef } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { BodisplayService, ActionBO } from './bodisplay.service';
import { BreadcrumbModel, QueovalParam, HtmlBase, BObjectModel, BreadDik, HtmlButton, PropertyData, QueovalItem, TableDefaultValue, PropertyGroup, eAppContext, TemplateModel, ModeBo, BObjectSummary } from '../models';
import { DragModalOption, DragModalService } from '../modal-draggable';
import { ModalService } from '../modal';
import { CoreService, HttpService, BreadcrumbService } from '../services';
import { ToastService } from '../toast';
import { DialogService } from '../dialog';
import { Router } from '@angular/router';
import { BoBaseComponent } from './bo.base.component';
import * as _jquery from 'jquery';
import * as _template from './template/index';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
const $: JQueryStatic = _jquery;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-bodisplay',
  templateUrl: './bodisplay.component.html',
  styleUrls: ['./bodisplay.component.css']
})

export class BodisplayComponent extends BoBaseComponent implements OnInit {
  private saveAfter: boolean = false;

  boDragOptions: DragModalOption = new DragModalOption();
  boDragModalId: string = 'boAdmin';
  dragContentShow: boolean = false;
  title: string;
  model: BObjectModel;
  safeURL: SafeResourceUrl;
  statusAdmin: boolean = false;
  breadcrump: BreadcrumbModel;
  showBo: boolean = false;
  isDevice: boolean = false;
  invalidItems: string[] = [];

  modeBo: ModeBo = ModeBo.Edit;
  modeBoEnum = ModeBo;
  filter: string = '';

  filterElement: Array<string> = new Array<string>();
  strMaxHeight: string = '';
  styleCustomBo: any;
  injectorTemplate: Injector;
  template: any;
  // (Cas ou l'on passe un breadcrumb model dont le model est un bodisplay) Charge les élements du model dans le html
  @Input('param')
  set param(value: QueovalParam) {
    if (value !== undefined) {
      this.showBo = false;
      this.model = value.model;
      const isLoaded: Array<BreadDik> = value.params.filter((element: BreadDik) => element.key === 'isLoaded');
      if (isLoaded.length === 0 || !isLoaded[0].value) {
        this.launch();
      } else {
        this.showBo = true;
        this.boReady.emit();
        this.sendBoReady.emit(this.model);
      }
    }
  }
  // (Cas ou l'on passe un model bodisplay uniquement) Charge les élements du model dans le html
  @Input('item')
  set item(value: BObjectModel) {
    if (value) {
      this.showBo = false;
      this.model = value;
      this.launch();
    }
  }
  // Permet d’enregistrer un bo en dehors de son contexte
  @Input('globalsave')
  set globalsave(value: boolean) {
    if (value === true) {
      this.showBo = false;
      //this.dialogservice.showSplash(true);
      this.model.Mode = 'SAVEBO';
      if (!this.saveDataBO()) {
        this.model.Error = 'NOTVALID';
        this.sendEvent.emit(this.model);
        //this.dialogservice.showSplash(false);
        //this.toastservice.showAlertToast(`${this.indParam.getAlert('ext_bo_saveNoWork')}`);
      }
    }
  }
  @Input('save')
  set SetSave(value: boolean) {
    if (value === true) {
      this.saveChange.emit(false);
      this.model.Mode = 'SAVEBO';
      if (!this.saveDataBO()) {
        this.model.Error = 'NOTVALID';
        this.sendEvent.emit(this.model);
      }
    }
  }
  @Output() saveChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  // Lorque l’on clique sur l’enregistrement d’un bo, permet de ne pas
  // enregistrer et de récupérer le model à enregistrer au niveau du composant parent
  @Input('saveAfter')
  set saveA(value: boolean) {
    if (value !== null || value !== undefined) {
      this.saveAfter = value;
    }
  }

  //Pour permettre de fixer une hauteur maximale (dans le cas où la bo se trouve dans une q-modale)
  @Input('maxHeight')
  set maxHeight(value: string) {
    if (value && value !== '') {
      this.strMaxHeight = value;
    }
  }


  @Input('modeBo') set IModeBo(value: ModeBo) {
    if (value && value != null) {
      this.modeBo = value
    } else {
      this.modeBo = ModeBo.Edit;
    }
  }

  @Input('filter') set IFilter(value: string) {
    if (value && value != null) {
      this.filter = value;
      if (this.showBo) {
        this.parseFilter(value);
      }
    }
  }

  @Input() sendWherePrefix: string;

  // output for save and delete action (return the updated model to parent component)
  @Output() sendEvent: EventEmitter<BObjectModel> = new EventEmitter<BObjectModel>();

  @Output() boReady: EventEmitter<void> = new EventEmitter<void>();
  // Envoie du BO une fois chargé
  @Output() sendBoReady: EventEmitter<BObjectModel> = new EventEmitter<BObjectModel>();
  @Output() sendFilter: EventEmitter<string> = new EventEmitter<string>();
  @Output() sendWhere: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('groupContainer', { static: false }) groupContainer: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event): any {
    const winW: number | undefined = $(window).width();
    this.isDevice = winW && winW <= 992 ? true : false;
    this.statusAdmin = this.isDevice ? false : this.indParam.getAutorisation('AdminBO');
  }

  constructor(
    private http: HttpService,
    private boservice: BodisplayService,
    private modalService: ModalService,
    private dialogservice: DialogService,
    private toastservice: ToastService,
    private dragModservice: DragModalService,
    protected router: Router,
    protected indParam: CoreService,
    protected bcrumb: BreadcrumbService,
    private inj: Injector,
    private cd: ChangeDetectorRef,
    private ngbModalService: NgbModal,
  ) { super(indParam, bcrumb, router); }

  ngOnInit(): void {
    const winW: number | undefined = $(window).width();
    this.isDevice = winW && winW <= 992 ? true : false;
    this.statusAdmin = this.isDevice ? false : this.indParam.getAutorisation('AdminBO');
    this.boDragOptions.title = 'Administration BO';

    this.result = this.boservice.getActionBO().subscribe((result: ActionBO) => {
      switch (result.action) {
        case 'DOCX': this.setDocxTitle(result.mode); break;
        //////case 'UPDSELECT': this.updateSelect(result.stringifyData); break;
        //////case 'INSPROP': this.insertProp(result.mode, result.stringifyData); break;
        //////case 'UPDPROP': this.updateProp(result.mode, result.stringifyData); break;
      }
    });


    this.styleCustomBo = {
      'max-height': this.strMaxHeight == '' ? '100%' : this.strMaxHeight
    };


  }

  setClassBtn(btn: HtmlButton): string {
    const cls: string = 'btn actionBtn';
    if (!btn.Visible)
      return 'btn btn-outline-dark hiddenBtn';

    switch (btn.ID.toUpperCase()) {
      case 'btnEnregistrer'.toUpperCase(): return `${cls} saveBtn`;
      case 'btnSupprimer'.toUpperCase(): return `${cls} removeBtn`;
      case 'btnModeCreer'.toUpperCase(): return `${cls} createBtn`;
      case 'btnImporter'.toUpperCase(): return `${cls} importBtn`;
      default: return cls;
    }
  }

  setClassBtnImg(btn: HtmlButton): string {
    switch (btn.ID.toUpperCase()) {
      case 'btnEnregistrer'.toUpperCase():
        switch (this.modeBo) {
          case ModeBo.Find:
            return 'fas fa-search';
          default:
            return `fas fa-save`;
        }

      case 'btnSupprimer'.toUpperCase(): return `fas fa-trash-alt`;
      case 'btnModeCreer'.toUpperCase(): return `fas fa-plus-circle`;
      case 'btnImporter'.toUpperCase(): return `fas fa-search-plus`;
      default: return '';
    }
  }

  openAdmin(): void {
    //this.openViewInBreadcrumb('view/admin/bo', `BO ${this.model.IdentBO} admin`, `id=${this.model.IdentBO}`);
    if (this.indParam.AppParams.context === eAppContext.QUEOVAL) {
      this.dragContentShow = true;
      this.dragModservice.open(this.boDragModalId);
    }
    else {
      this.toastservice.showInfoToast(`Veuiller vous connecter à l'ERP pour modifier le ${this.model.NameBO}`);
    }
  }

  // Fermeture de la modal de suppression
  closeDeleteModal(): void {
    this.modalService.close('deleteModal');
  }

  // Enregistrmeent, suppression ou modification des données du bo.
  action(button: HtmlBase): void {
    const btnID: string = button.ID;
    switch (btnID) {
      case 'btnEnregistrer':
        this.model.Mode = 'SAVEBO';
        if (!this.saveDataBO()) {

        }
        break;
      case 'btnSupprimer':
        this.modalService.open('deleteModal');
        break;
      case 'btnModeCreer':
        this.dialogservice.showAlert('not implemented');
        break;
    }
  }

  // confirmation de suppression
  delete(): void {
    this.showBo = false;
    //this.dialogservice.showSplash(true);
    this.model.Mode = 'REMOVEBO';
    this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, this.model).subscribe((result: BObjectModel) => {
      this.showBo = true;
      //this.dialogservice.showSplash(false);
      this.toastservice.showSuccessToast(result.Alert);
      this.modalService.close('deleteModal');
      this.sendEvent.emit(this.model);
    }, () => { this.showBo = true; }); //this.dialogservice.showSplash(false); });
  }

  // recupere le breadcrumb model envoyé par les dynamictags
  getBreadcrump(breadcrump: BreadcrumbModel): void {
    if (this.ngbModalService.hasOpenModals())
      this.ngbModalService.dismissAll();
  }

  public AffectBoDatas(data: BObjectModel): void {
    if (!data.HasError) {
      this.model = data;
      this.template = _template;
      this.injectorTemplate = Injector.create([
        {
          provide: TemplateModel, useValue: new TemplateModel(
            this.model.IdDonneePere,
            this.model.IdDonneeFils,
            this.model.IdRelation,
            this.model.IdentBO
          )
        }
      ], this.inj);


      this.showBo = true;
      setTimeout(() => {
        this.boReady.emit();
        this.sendBoReady.emit(data);
      }, 5);
      //////this.cd.detectChanges();
      this.parseFilter(this.filter);
    }
    this.showBo = true;
    //this.dialogservice.showSplash(false);
  }

  // Chargement du bo
  private launch(): void {
    this.showBo = false;
    //this.dialogservice.showSplash(true);
    this.model.Mode = 'CREATE';
    this.result = this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, this.model).subscribe((data: BObjectModel) => {
      this.AffectBoDatas(data);
    });
  }

  // Méthode de validation des inputs, vérifie que tous les inputs respectent les conditions (require, regex, type, format)
  private validation(): boolean {
    this.invalidItems = [];
    for (const group of this.model.Body.SelectedGroupsList) {

      //////////const test: PropertyData[] = group.DataList.filter((property: PropertyData) => property.QueovalCode === 'LISTGRPCNX');
      //////////if (test.length > 0) {
      //////////  const test2: PropertyData = test[0];
      //////////}

      // #region CHECK ITEMS REQUIRED

      const requiredItems: PropertyData[] = group.DataList.filter((property: PropertyData) => property.MainElementList.length > 0 && property.MainElementList[0].Required);

      // #region check input items (get required items different from selected with value empty)
      const requiredItemsInput: PropertyData[] = requiredItems.filter((select: PropertyData) => select.MainElementList[0].TagName !== 'SELECT' && select.MainElementList[0].TagName !== 'SELECTMOD' && select.MainElementList[0].Value === '');
      requiredItemsInput.forEach((p: PropertyData) => { p.MainElementList[0].InValid = true; this.invalidItems.push(p.MainLabel.Value); });
      //#endregion

      // #region check select items
      const requiredItemsSelect: PropertyData[] = requiredItems.filter((select: PropertyData) => (select.MainElementList[0].TagName === 'SELECT' || select.MainElementList[0].TagName === 'SELECTMOD'));
      requiredItemsSelect.forEach((select: PropertyData) => {
        const selOP: QueovalItem[] = select.MainElementList[0].SelectOptionsList.filter((e: QueovalItem) => e.Selected && (e.Value === '' || e.Value === '-1'));
        if (selOP.length > 0) {
          select.MainElementList[0].InValid = true;
          this.invalidItems.push(select.MainLabel.Value);
        }
      });
      // #endregion

      // #endregion

      // #region CHECK VALID-EXP ITEMS
      const validExpItems: PropertyData[] = group.DataList.filter((item: PropertyData) => {
        const required: boolean = item.MainElementList.length > 0 && item.MainElementList[0].Required && item.MainElementList[0].ValidExp !== '';
        const others: boolean = item.MainElementList.length > 0 && !item.MainElementList[0].Required && item.MainElementList[0].ValidExp !== '' && item.MainElementList[0].Value !== '';
        return required || others;
      });

      validExpItems.forEach((p: PropertyData) => {
        p.MainElementList[0].InValid = !new RegExp(p.MainElementList[0].ValidExp).test(String(p.MainElementList[0].Value));
        if (p.MainElementList[0].InValid) this.invalidItems.push(p.MainLabel.Value);
      });

      // #endregion
    }

    return this.invalidItems.length === 0;
  }

  public externalSave(): boolean {
    return this.saveDataBO();
  }

  // Enregistrement du bo
  private saveDataBO(): boolean {

    switch (this.modeBo) {
      default:
      case ModeBo.Edit:


        this.showBo = false;
        const valid: boolean = this.validation();
        this.showBo = true;
        if (!valid) {
          if (this.invalidItems.length > 0) {
            const alertMsg: string = this.invalidItems.map(function (e: string): string { return e; }).join(', ');
            this.toastservice.showAlertToast(`Remplissez les champs suivants avec les données appropriées: <br /> ${alertMsg}`);
            this.toastservice.showAlertToast(`${this.indParam.getTrad('ext_bo_saveNoWork')}`);
            return false;
          }
        }
        this.showBo = false;
        //this.dialogservice.showSplash(true);
        if (this.saveAfter) {
          this.sendEvent.emit(this.model);
          return true;
        }

        this.result = this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, this.model).subscribe((result: BObjectModel) => {
          this.model = result;
          this.showBo = true;
          //this.dialogservice.showSplash(false);
          this.sendEvent.emit(this.model);
        });
        return true;
        break;


      case ModeBo.Find:
        this.filterElement = Array<string>();
        for (const group of this.model.Body.SelectedGroupsList) {
          for (const prop of group.DataList) {
            this.buildFilter(prop);
          }
        }
        this.sendWhere.emit(this.getWhere(this.sendWherePrefix));

        this.sendFilter.emit(this.filterElement.join('|'));
        this.showBo = true;
        //this.dialogservice.showSplash(false);
        return true;
        break;
    }
  }

  //private buildWhere(prop: PropertyData, pWhere: Array<string>) {

  //  if (prop.MainElementList[0].Value
  //    || prop.MainElementList[0].Filter == 'null'
  //    || prop.MainElementList[0].Filter == 'notnull'
  //    || (prop.MainElementList[1].Value && ['CPVILLE', 'DATE'].includes(prop.QueovalCode))
  //    || (prop.QueovalCode == 'DATE' && (prop.MainElementList[1].Filter == 'null' || prop.MainElementList[1].Filter == 'notnull'))) {
  //    let colName: string = '';
  //    switch (prop.QueovalCode) {
  //      case 'CPVILLE':
  //        colName = prop.MainElementList[0].ID.replace('_codepos', '');
  //        break;
  //      default:
  //        colName = prop.MainElementList[0].ID;
  //        break;
  //    }
  //    let condition1 = '';
  //    let condition2 = '';
  //    switch (prop.QueovalCode) {
  //      case 'CHECKBOX':
  //        if (prop.MainElementList[0].Value && prop.MainElementList[0].Value != 'Equals') {
  //          condition1 = '=';
  //        }
  //        break;

  //      case 'DATE':
  //        if (prop.MainElementList[0].Value || prop.MainElementList[0].Filter == 'null' || prop.MainElementList[0].Filter == 'notnull') {
  //          condition1 = GetCondition(prop.MainElementList[0].Filter);
  //        }

  //        if (prop.MainElementList[1].Value || prop.MainElementList[1].Filter == 'null' || prop.MainElementList[1].Filter == 'notnull') {
  //          condition2 = GetCondition(prop.MainElementList[1].Filter);
  //        }
  //        break;
  //      case 'CPVILLE':
  //        if (prop.MainElementList[0].Value || prop.MainElementList[1].Value || prop.MainElementList[0].Filter == 'null' || prop.MainElementList[0].Filter == 'notnull') {
  //          condition1 = GetCondition(prop.MainElementList[0].Filter);
  //        }
  //        //switch (prop.MainElementList[0].Filter) {
  //        //  case 'null':
  //        //    this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|,|Equals`);
  //        //    break;
  //        //  case 'notnull':
  //        //    this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|,|Diff`);
  //        //    break;
  //        //  case 'Like':
  //        //    if (prop.MainElementList[0].Value && prop.MainElementList[1].Value) {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%${prop.MainElementList[0].Value}%,%${prop.MainElementList[1].Value}%|${prop.MainElementList[0].Filter}`);
  //        //    } else if (prop.MainElementList[0].Value) {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%${prop.MainElementList[0].Value}%,%|${prop.MainElementList[0].Filter}`);
  //        //    } else if (prop.MainElementList[1].Value) {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%,%${prop.MainElementList[1].Value}%|${prop.MainElementList[0].Filter}`);
  //        //    }
  //        //    break;
  //        //  case 'LikeDeb':
  //        //    if (prop.MainElementList[0].Value && prop.MainElementList[1].Value) {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value}%,${prop.MainElementList[1].Value}%|${prop.MainElementList[0].Filter}`);
  //        //    } else if (prop.MainElementList[0].Value) {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value}%,%|${prop.MainElementList[0].Filter}`);
  //        //    } else if (prop.MainElementList[1].Value) {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%,${prop.MainElementList[1].Value}%|${prop.MainElementList[0].Filter}`);
  //        //    }
  //        //    break;
  //        //  case 'CPDiff':
  //        //  case 'CPEquals':
  //        //    if (prop.MainElementList[0].Value && prop.MainElementList[1].Value) {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value},${prop.MainElementList[1].Value}|${prop.MainElementList[0].Filter}`);
  //        //    } else if (prop.MainElementList[0].Value) {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value},%|${prop.MainElementList[0].Filter}`);
  //        //    } else if (prop.MainElementList[1].Value) {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%,${prop.MainElementList[1].Value}|${prop.MainElementList[0].Filter}`);
  //        //    }
  //        //    break;
  //        //  default:
  //        //    if (prop.MainElementList[0].Value || prop.MainElementList[1].Value || prop.MainElementList[0].Filter == 'null' || prop.MainElementList[0].Filter == 'notnull') {
  //        //      this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value},${prop.MainElementList[1].Value}|${prop.MainElementList[0].Filter}`);
  //        //    }
  //        //    break;
  //        //}

  //        break;
  //      default:
  //        if (prop.MainElementList[0].Value || prop.MainElementList[0].Filter == 'null' || prop.MainElementList[0].Filter == 'notnull') {
  //          condition1 = GetCondition(prop.MainElementList[0].Filter);
  //        }
  //        break;
  //    }

  //    switch (prop.QueovalCode) {
  //      case 'CHECKBOX':
  //        if (prop.MainElementList[0].Value && prop.MainElementList[0].Value != 'Equals') {
  //          pWhere.push(`${colName} ${condition1} ${prop.MainElementList[0].Value}`);
  //        }
  //        break;

  //      case 'DATE':
  //        if (prop.MainElementList[0].Filter == 'null' || prop.MainElementList[0].Filter == 'notnull') {
  //          pWhere.push(`${colName} ${condition1}`);
  //        } else if (prop.MainElementList[0].Value) {
  //          pWhere.push(`${colName} ${condition1} ${prop.MainElementList[0].Value}`);
  //        }
  //        if (prop.MainElementList[1].Filter == 'null' || prop.MainElementList[1].Filter == 'notnull') {

  //        } else if (prop.MainElementList[1].Value) {
  //          pWhere.push(`${colName} ${condition2} ${prop.MainElementList[1].Value}`);
  //        }
  //        break;
  //      case 'CPVILLE':
  //        if (prop.MainElementList[0].Filter == 'null' || prop.MainElementList[0].Filter == 'notnull') {
  //          pWhere.push(`${colName} ${condition1}`);
  //        } else if (prop.MainElementList[0].Value && prop.MainElementList[1].Value) {
  //          pWhere.push(`${colName} ${condition1} ${prop.MainElementList[1].Value}`);
  //        } else if (prop.MainElementList[0].Value || prop.MainElementList[1].Value) {

  //        }
  //        break;
  //      default:
  //        value1 = prop.MainElementList[0].Value;
  //    }

  //  }


  //  function GetCondition(filter: string): string {

  //    switch (filter.toLowerCase()) {
  //      case 'null':
  //        return 'is null';
  //      case 'notnull':
  //        return 'is not null';
  //      case '-1':
  //      case 'equals':
  //        return '=';
  //      case 'diff':
  //        return '<>';
  //      case 'inf':
  //        return '<';
  //      case 'infequal':
  //        return '<=';
  //      case 'sup':
  //        return '>';
  //      case 'supequal':
  //        return '>=';
  //      case 'cpequals':
  //      case 'deb':
  //      case 'cont':
  //      case 'likedeb':
  //      case 'like':
  //        return 'like';
  //      case 'cpdiff':
  //      case 'notcont':
  //        return 'not like';
  //    }
  //    return '';
  //  }
  //}


  public getWhere(pStrPrefix: string): string {
    const strFiltre: string = this.filterElement.join('|');
    var strArrayFiltre: string[];
    var booIsString: boolean = false;
    let stbWhere: string = '';
   
    if (strFiltre) {
        strArrayFiltre = strFiltre.split('|');
        let arrWhere: string[] = [];
        for (var n: number = 0; n < strArrayFiltre.length; n += 3) {
          const colSummary: BObjectSummary[] = this.model.summary.filter(sum => sum.ColumnName == strArrayFiltre[n]);
          if (colSummary.length == 1) {
            const proElem = this.model.Body.SelectedGroupsList[colSummary[0].IndexGroupsList].DataList[colSummary[0].IndexDataList];
            switch (proElem.Type) {
              case 'DATETIME':
              case 'NVARCHAR':
                booIsString = true;
                break;
              default:
                booIsString = false;
                break;
            }
            arrWhere.push(GetOperateur(strArrayFiltre[n + 2], booIsString, strArrayFiltre[n], strArrayFiltre[n + 1], pStrPrefix));
          }
        }
        stbWhere = arrWhere.join(' and ');
    }
    if (!stbWhere.replace(/ /g, '')) {
      return " 1 = 1 ";
    }
    return stbWhere;

    function GetOperateur(pStrOperateur: string, pBooString: boolean, pStrChamps: string, pStrValeur: string, pStrPrefix: string): string {
      let strResult: string = '';
      pStrPrefix = pStrPrefix ? pStrPrefix + '.' : '';
    switch (pStrOperateur) {
      case "Inf":
        strResult = pStrPrefix + pStrChamps + " < " + (pBooString == true ? `'${pStrValeur.replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "InfEqual":
        strResult = pStrPrefix + pStrChamps + " <= " + (pBooString == true ? `'${pStrValeur.replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "Sup":
        strResult = pStrPrefix + pStrChamps + " > " + (pBooString == true ? `'${pStrValeur.replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "SupEqual":
        strResult = pStrPrefix + pStrChamps + " >= " + (pBooString == true ? `'${pStrValeur.replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "deb":
        strResult = pStrPrefix + pStrChamps + " like " + (pBooString == true ? `'${(pStrValeur + '%').replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "Cont":
        strResult = pStrPrefix + pStrChamps + " like " + (pBooString == true ? `'${('%' + pStrValeur + '%').replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "NotCont":
        strResult = pStrPrefix + pStrChamps + " not like " + (pBooString == true ? `'${('%' + pStrValeur + '%').replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "Equals":
        strResult = pStrPrefix + pStrChamps + " = " + (pBooString == true ? `'${pStrValeur.replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "Diff":
        strResult = pStrPrefix + pStrChamps + " <> " + (pBooString == true ? `'${pStrValeur.replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "null":
        strResult = pStrPrefix + pStrChamps + " is null";
        break;
      case "notnull":
        strResult = pStrPrefix + pStrChamps + " is not null";
        break;
      case "CPEquals":
      case "LikeDeb":
      case "Like":
        strResult = pStrPrefix + pStrChamps + " like " + (pBooString == true ? `'${pStrValeur.replace(/'/g, "''")}'` : pStrValeur);
        break;
      case "CPDiff":
        strResult = pStrPrefix + pStrChamps + " not like " + (pBooString == true ? `'${pStrValeur.replace(/'/g, "''")}'` : pStrValeur);
        break;
      default:
        strResult = pStrPrefix + pStrChamps + " = " + pStrValeur;
        break;
    }
    return strResult;
  }
  }

  private buildFilter(prop: PropertyData): void {


    switch (prop.QueovalCode) {
      case 'CHECKBOX':
        if (prop.MainElementList[0].Value && prop.MainElementList[0].Value != 'Equals') {
          this.filterElement.push(`${prop.MainElementList[0].ID}|${prop.MainElementList[0].Value}|`);
        }
        break;

      case 'DATE':
        if (prop.MainElementList[0].Value || prop.MainElementList[0].Filter == 'null' || prop.MainElementList[0].Filter == 'notnull') {
          this.filterElement.push(`${prop.MainElementList[0].ID}|${prop.MainElementList[0].Value}|${prop.MainElementList[0].Filter}`);
        }

        if (prop.MainElementList[1].Value || prop.MainElementList[1].Filter == 'null' || prop.MainElementList[1].Filter == 'notnull') {
          this.filterElement.push(`${prop.MainElementList[1].ID}|${prop.MainElementList[1].Value}|${prop.MainElementList[1].Filter}`);
        }
        break;
      case 'CPVILLE':
        switch (prop.MainElementList[0].Filter) {
          case 'null':
            this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|,|Equals`);
            break;
          case 'notnull':
            this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|,|Diff`);
            break;
          case 'Like':
            if (prop.MainElementList[0].Value && prop.MainElementList[1].Value) {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%${prop.MainElementList[0].Value}%,%${prop.MainElementList[1].Value}%|${prop.MainElementList[0].Filter}`);
            } else if (prop.MainElementList[0].Value) {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%${prop.MainElementList[0].Value}%,%|${prop.MainElementList[0].Filter}`);
            } else if (prop.MainElementList[1].Value) {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%,%${prop.MainElementList[1].Value}%|${prop.MainElementList[0].Filter}`);
            }
            break;
          case 'LikeDeb':
            if (prop.MainElementList[0].Value && prop.MainElementList[1].Value) {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value}%,${prop.MainElementList[1].Value}%|${prop.MainElementList[0].Filter}`);
            } else if (prop.MainElementList[0].Value) {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value}%,%|${prop.MainElementList[0].Filter}`);
            } else if (prop.MainElementList[1].Value) {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%,${prop.MainElementList[1].Value}%|${prop.MainElementList[0].Filter}`);
            }
            break;
          case 'CPDiff':
          case 'CPEquals':
            if (prop.MainElementList[0].Value && prop.MainElementList[1].Value) {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value},${prop.MainElementList[1].Value}|${prop.MainElementList[0].Filter}`);
            } else if (prop.MainElementList[0].Value) {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value},%|${prop.MainElementList[0].Filter}`);
            } else if (prop.MainElementList[1].Value) {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|%,${prop.MainElementList[1].Value}|${prop.MainElementList[0].Filter}`);
            }
            break;
          default:
            if (prop.MainElementList[0].Value || prop.MainElementList[1].Value || prop.MainElementList[0].Filter == 'null' || prop.MainElementList[0].Filter == 'notnull') {
              this.filterElement.push(`${prop.MainElementList[0].ID.replace('_codepos', '')}|${prop.MainElementList[0].Value},${prop.MainElementList[1].Value}|${prop.MainElementList[0].Filter}`);
            }
            break;
        }

        break;
      default:
        if (prop.MainElementList[0].Value || prop.MainElementList[0].Filter == 'null' || prop.MainElementList[0].Filter == 'notnull') {
          this.filterElement.push(`${prop.MainElementList[0].ID}|${prop.MainElementList[0].Value}|${prop.MainElementList[0].Filter}`);
        }
        break;
    }




  }

  private parseFilter(filter: string): void {
    if (filter) {
      let filterSplited: string[] = filter.split('|');
      let listFiltre: Array<any> = new Array<any>();

      for (let i: number = 0; i < filterSplited.length; i += 3) {
        let colId: string = filterSplited[i];
        let propValue: string = filterSplited[i + 1];
        let filterValue: string = filterSplited[i + 2];
        listFiltre.push({ id: colId, prop: propValue, filter: filterValue });
      }

      for (const group of this.model.Body.SelectedGroupsList) {
        for (const prop of group.DataList) {
          let filterF: any = listFiltre.filter((f: any) => { return f.id == prop.MainElementList[0].ID || (prop.MainElementList.length > 1 && f.id == prop.MainElementList[1].ID) });
          if (filterF.length > 0) {
            switch (prop.QueovalCode) {

              case 'DATE':
                prop.MainElementList[0].Value = filterF[0].prop;
                prop.MainElementList[0].Filter = filterF[0].filter;
                prop.MainElementList[0].Required = true;
                if (filterF.length == 2) {
                  prop.MainElementList.push(JSON.parse(JSON.stringify(prop.MainElementList[0])));
                  prop.MainElementList[1].Value = filterF[1].prop;
                  prop.MainElementList[1].Filter = filterF[1].filter;
                  prop.MainElementList[1].Required = true;
                }
                break;
              case 'CPVILLE':
                const value1: string = filterF[0].prop.split(',')[0];
                prop.MainElementList[0].Value = value1 === '%' && (filterF[0].filter === 'CPEquals' || filterF[0].filter === 'CPDiff') ?
                  ''
                  : filterF[0].filter === 'LikeDeb' ?
                    value1.slice(0, value1.length - 1)
                    : filterF[0].filter === 'Like' ?
                      value1.slice(1, value1.length - 1)
                      : value1;
                const value2: string = filterF[0].prop.split(',').length > 1 ? filterF[0].prop.split(',')[1] : '';
                prop.MainElementList[1].Value = value2 === '' || (value2 === '%' && (filterF[0].filter === 'CPEquals' || filterF[0].filter === 'CPDiff')) ?
                  ''
                  : filterF[0].filter === 'LikeDeb' ?
                    value2.slice(0, value2.length - 1)
                    : filterF[0].filter === 'Like' ?
                      value2.slice(1, value2.length - 1)
                      : value2;;

                prop.MainElementList[0].Filter = filterF[0].prop === ',' ? (filterF[0].filter === 'Equals' ? 'null' : filterF[0].filter === 'Diff' ? 'notnull' : filterF[0].filter) : filterF[0].filter;
                prop.MainElementList[0].Required = true;
                prop.MainElementList[1].Required = true;
                break;

              default:
                prop.MainElementList[0].Value = filterF[0].prop;
                prop.MainElementList[0].Filter = filterF[0].filter;
                prop.MainElementList[0].Required = true;
                break;
            }
          }
        }
      }
    }
  }

  /**
   * Vide un boFind
   */
  public emptyABoFind(): void {
    if (this.modeBo == ModeBo.Find) {
      for (const group of this.model.Body.SelectedGroupsList) {
        for (const prop of group.DataList) {
          prop.MainElementList[0].Value = '';
          prop.MainElementList[0].Filter = prop.FilterBo[0].key;
          prop.MainElementList[0].Required = false;

          if (prop.QueovalCode == 'DATE' || prop.QueovalCode == 'CPVILLE') {
            prop.MainElementList[1].Value = '';
            prop.MainElementList[1].Filter = prop.FilterBo[0].key;
            prop.MainElementList[1].Required = false;
          }
        }
      }
    }
  }

  public OnModelChange(newModel: BObjectModel): void {
    this.model = newModel;
    this.cd.detectChanges();
  }
  //#region authomatic updates

  // get the docx title from insertdoc component and set the correspondent BO property
  private setDocxTitle(docxTitle: string): void {
    const item: HtmlBase | null = this.getPropItemByCode('TITREDOC');
    if (item) {
      item.Value = docxTitle;
      this.model.Header.ButtonsList[0].Visible = true;
    }
  }
  //////// get the property by its code and update the correspondent select's list of options
  //////private updateProp(propCode: string, data: string): void {
  //////  const dataObj: TableDefaultValue[] = JSON.parse(data);
  //////  const item: HtmlBase | null = this.getPropItemByCode(propCode);
  //////  if (item) {
  //////    if (item.TagName.toUpperCase() === 'SELECT') {
  //////      item.SelectOptionsList = [];
  //////      item.SelectOptionsList.push({ Selected: item.Value === '', Value: '', Text: '- - - - -' });
  //////      dataObj.forEach((d: TableDefaultValue) => { item.SelectOptionsList.push({ Selected: item.Value === d.VastrBOV, Value: d.VastrBOV, Text: d.Info_BOV }); });
  //////    }
  //////  }
  //////}
  //////// get property by its code and insert the new option in the select's list of options
  //////private insertProp(propCode: string, data: string): void {
  //////  const dataObj: TableDefaultValue = JSON.parse(data);
  //////  const item: HtmlBase | null = this.getPropItemByCode(propCode);
  //////  if (item) {
  //////    if (item.TagName.toUpperCase() === 'SELECT') {
  //////      item.SelectOptionsList.push({ Selected: item.Value === dataObj.VastrBOV, Value: dataObj.VastrBOV, Text: dataObj.Info_BOV });
  //////    }
  //////  }
  //////}
  //////// update the select's options'list in all of the select-type-properties linked to the same values-group
  //////private updateSelect(data: string): void {
  //////  const dataObj: TableDefaultValue = JSON.parse(data);
  //////  const itmList: HtmlBase[] = this.getPropItemByTage('SELECT');
  //////  itmList.forEach((e: HtmlBase) => {
  //////    const l: QueovalItem[] = e.SelectOptionsList.filter((x: QueovalItem) => x.Value === dataObj.VastrBOV);
  //////    l.forEach((i: QueovalItem) => { i.Text = dataObj.Info_BOV; });
  //////  });
  //////}
  private getPropItemByCode(propCode: string): HtmlBase | null {
    let result: HtmlBase | null = null;
    for (let i: number = 0; i < this.model.Body.SelectedGroupsList.length; i++) {
      const el: PropertyData[] = this.model.Body.SelectedGroupsList[i].DataList.filter((p: PropertyData) => p.MainElementList.length > 0 && p.MainElementList[0].ID.toUpperCase() === propCode);
      if (el.length > 0) {
        result = el[0].MainElementList[0];
        break;
      }
    }
    return result;
  }
  //////private getPropItemByTage(tagName: string): HtmlBase[] {
  //////  const result: HtmlBase[] = [];
  //////  this.model.Body.SelectedGroupsList.forEach((group: PropertyGroup) => {
  //////    const el: PropertyData[] = group.DataList.filter((p: PropertyData) => p.MainElementList.length > 0 && p.MainElementList[0].TagName.toUpperCase() === tagName);
  //////    if (el.length > 0) {
  //////      el.forEach((p: PropertyData) => { result.push(p.MainElementList[0]); });
  //////    }
  //////  });
  //////  return result;
  //////}

  //#endregion







  //////showGroups(): boolean {
  //////  //return this.isAdmin && this.statusAdmin && this.model.Body.GroupsList.length > 0;
  //////  return this.displayAdmin && this.model.Body.GroupsList.length > 0;
  //////}

  //////// méthode de modification des options du gridster en fcontion des droits d'admin ( resize and drag )
  //////public optionControl(): void {
  //////  ////////////// Vérifie les droits d'administration en fonction de la taille de l'écran
  //////  ////////////this.mobile = this.htmlComponent.nativeElement.children[0].clientWidth <= 768 ? true : false;
  //////  ////////////// tslint:disable-next-line:max-line-length
  //////  ////////////// this.statusAdmin = this.htmlComponent.nativeElement.clientWidth <= 992 ? false : this.indParam.getAutorisation('AdminBO') ? true : false;

  //////  ////////////if (this.htmlComponent.nativeElement.children[0].clientWidth <= 992) {
  //////  ////////////  this.statusAdmin = false;
  //////  ////////////} else {
  //////  ////////////  this.statusAdmin = this.indParam.getAutorisation('AdminBO');
  //////  ////////////}

  //////  ////////////if (this.statusAdmin && this.adminGridster === 'bodisplay') {
  //////  ////////////  this.isAdmin = !this.isAdmin;
  //////  ////////////  if (this.options.draggable) {
  //////  ////////////    this.options.draggable.enabled = this.isAdmin;
  //////  ////////////  }
  //////  ////////////  if (this.options.resizable) {
  //////  ////////////    this.options.resizable.enabled = this.isAdmin;
  //////  ////////////  }
  //////  ////////////  if (this.options.api && this.options.api.optionsChanged) {
  //////  ////////////    this.options.api.optionsChanged();
  //////  ////////////  }
  //////  ////////////}
  //////  this.displayAdmin = !this.displayAdmin;
  //////  if (this.options.draggable) {
  //////    this.options.draggable.enabled = this.displayAdmin;
  //////  }
  //////  if (this.options.resizable) {
  //////    this.options.resizable.enabled = this.displayAdmin;
  //////  }
  //////  if (this.options.api && this.options.api.optionsChanged) {
  //////    this.options.api.optionsChanged();
  //////  }
  //////}

  //////////// Lorsque l'on commence le drag on affecte l'item selectionné au selectedGroup du model
  //////////public dragElement(item: PropertyGroup): void {
  //////////  this.model.Body.SelectedGroup = item;
  //////////}

  //////////// Suppression d'un block du bo
  //////////public removeGroup(group: PropertyGroup): void {
  //////////  // remove the selected group from the list of the groups to display
  //////////  this.model.Body.SelectedGroupsList.splice(this.model.Body.SelectedGroupsList.indexOf(group), 1);
  //////////  // add the selected group to the list of the hidden groups
  //////////  this.model.Body.GroupsList.push(group);

  //////////  this.model.Body.SelectedGroup = group;
  //////////  this.model.Mode = 'REMOVEPOSITION';
  //////////  this.dialogservice.showSplash(true);
  //////////  this.subscript = this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, this.model).subscribe(() => {
  //////////    this.dialogservice.showSplash(false);
  //////////  });
  //////////}

  //////////// modifie la taille ou deplace un item dans la gridster
  //////////private itemChange(item: GridsterItem, itemComponent: GridsterItemComponentInterface): void {
  //////////  for (let i: number = 0; i < this.model.Body.SelectedGroupsList.length; i++) {
  //////////    if (this.model.Body.SelectedGroupsList[i].ID === item.ID) {
  //////////      this.model.Body.SelectedGroup = this.model.Body.SelectedGroupsList[i];
  //////////    }
  //////////  }
  //////////  this.saveBo(true);
  //////////}

  //////////// Evenement d'enregistrement du nouveau block
  //////////private saveBo(isUpdate: boolean): void {
  //////////  this.model.Mode = isUpdate ? 'UPDATEPOSITION' : 'INSERTGROUP';
  //////////  this.dialogservice.showSplash(true);
  //////////  this.subscript = this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, this.model).subscribe(() => {
  //////////    this.dialogservice.showSplash(false);
  //////////  });
  //////////}

  // Action lorsque l'on inserte un nouveau block dans le gridster
  //////////private dropElement(event: MouseEvent, item: GridsterItem): void {
  //////////  if (this.model.Body.SelectedGroup !== null) {
  //////////    this.model.Body.SelectedGroup.x = item.x;
  //////////    this.model.Body.SelectedGroup.y = item.y;
  //////////    // remove element from the base groups list
  //////////    const index: number = this.model.Body.GroupsList.indexOf(this.model.Body.SelectedGroup);
  //////////    if (index > -1) { this.model.Body.GroupsList.splice(index, 1); }
  //////////    // add element to the selected groups list
  //////////    this.model.Body.SelectedGroupsList.push(this.model.Body.SelectedGroup);
  //////////    this.optionControl();
  //////////    this.saveBo(false);
  //////////  }
  //////////}

}
